import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const Hairline = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};
  margin: ${barnesTheme.spacing.contentGap} 0;

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    margin: ${barnesTheme.spacing.contentGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricsRow = styled.div`
  display: flex;
  gap: ${barnesTheme.spacing.sectionGap};
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    display: flex !important;
    gap: ${barnesTheme.spacing.sectionGap} !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const MetricCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
`

export const MetricLabel = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricValue = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.xlarge};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  line-height: 1.2;
  margin-top: 4px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: ${barnesTheme.fontSizes.xlarge} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    line-height: 1.2 !important;
    margin-top: 4px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricValueAccent = styled(MetricValue)`
  color: ${barnesTheme.colors.accent};

  @media print {
    color: ${barnesTheme.colors.accent} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricTrend = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.contentGap};
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.contentGap} !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
  }
`

export const ChartContainer = styled.div`
  width: 100%;
  padding: 12px 0;
  box-sizing: border-box;
  position: relative;

  @media print {
    width: 100% !important;
    padding: 12px 0 !important;
    box-sizing: border-box !important;
    position: relative !important;
  }
`

export const ChartTitle = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 13px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};
  margin-bottom: 8px;

  @media print {
    font-size: 13px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    margin-bottom: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MarketTrend = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  line-height: 1.6;
  margin-top: ${barnesTheme.spacing.contentGap};

  @media print {
    font-size: ${barnesTheme.fontSizes.small} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1.6 !important;
    margin-top: ${barnesTheme.spacing.contentGap} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: ${barnesTheme.spacing.smallGap};
  justify-content: center;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 20px !important;
    margin-top: ${barnesTheme.spacing.smallGap} !important;
    justify-content: center !important;
  }
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  color: ${barnesTheme.colors.textLight};

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
    font-size: 8px !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const LegendLine = styled.div<{ $color: string }>`
  width: 20px;
  height: 2px;
  background: ${({ $color }) => $color};

  @media print {
    width: 20px !important;
    height: 2px !important;
    background: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
